/**
 * A mounted screen may write the URL (list filters, or a redirect that
 * finishes async work) only while the address bar is still on the route
 * captured from `useLocation`. After a link away, the bar updates immediately
 * but React Router can keep the old screen mounted until a lazy route chunk
 * loads.
 */
export function isLiveAtListPath(capturedPathname: string): boolean {
  return window.location.pathname === capturedPathname;
}
